<script setup>
import { onMounted, computed, ref, defineProps } from "vue";
import { useStore } from "vuex";
// import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import _ from "lodash";
// import Swal from "sweetalert2";
import axios from "axios";
import { authHeader } from "@/helpers/authservice/auth-header";

// const userRoles = computed(() => JSON.parse(localStorage.getItem("roles")));
// const roleExist = (slug) => {
//   if (userRoles.value && userRoles.value.length) {
//     return userRoles.value.some((obj) => obj.slug === slug);
//   }

//   return false;
// };

// const slicedOwnerAddress = (address) => {
//   // REMOVE THESE WORDS TO ADDRESS ALSO REMOVE NUMBERS
//   let wordsToRemove = ["FIRST", "SECOND", "THIRD", "FOURTH", "DISTRICT"];

//   let upperAddress = address.join(" ").toUpperCase();

//   let modifiedAddress = address.filter(
//     (address) => !wordsToRemove.includes(address)
//   );
//   // REMOVE SINGLE CHARACTER WORD
//   modifiedAddress = modifiedAddress.filter(
//     (modifiedAddress) => modifiedAddress.length > 1
//   );
//   // REMOVE NCR IF THERE IS NATIONAL CAPITAL REGION
//   if (upperAddress.includes("NATIONAL CAPITAL REGION")) {
//     modifiedAddress = modifiedAddress.filter(
//       (modifiedAddress) => modifiedAddress !== "NCR"
//     );
//   }

//   // TRIM ADDRESS
//   if (modifiedAddress.length >= 13) {
//     return modifiedAddress.slice(-7).join(" ");
//   } else if (modifiedAddress.length < 13 && modifiedAddress.length >= 10) {
//     return modifiedAddress.slice(-6).join(" ");
//   } else if (modifiedAddress.length < 10 && modifiedAddress.length >= 7) {
//     return modifiedAddress.slice(-5).join(" ");
//   } else if (modifiedAddress.length < 7 && modifiedAddress.length >= 5) {
//     return modifiedAddress.slice(-4).join(" ");
//   } else if (modifiedAddress.length == 4) {
//     return modifiedAddress.slice(-3).join(" ");
//   } else if (modifiedAddress.length == 3) {
//     return modifiedAddress.slice(-2).join(" ");
//   } else {
//     return modifiedAddress.slice(-1).join(" ");
//   }
// };

const props = defineProps({
  editable: {
    type: Boolean,
    default: true,
  },
  lgu_has_speed_violation: {
    type: Array,
    required: true,
  },
});

onMounted(async () => {
  await getMVFileRecord();
  await searchQuery();
  original_name.value = mv_file_record.value.name;
});

const traffic_record = computed(
  () => store.state.trafficRecordComponent.traffic_record
);
const mv_file_record = computed({
  get: () => store.state.trafficRecordComponent.mv_file_record,
  set: (val) => store.commit("trafficRecordComponent/SET_MV_FILE_RECORD", val),
});
const input_speed_limit = computed({
  get: () => store.state.trafficRecordComponent.input_speed_limit,
  set: (val) =>
    store.commit("trafficRecordComponent/SET_INPUT_SPEED_LIMIT", val),
});
const original_name = ref(null);

const store = useStore();

const getMVFileRecord = async () =>
  await store.dispatch("trafficRecordComponent/getMVFileRecord");

const loading = computed(() => store.state.globals.loading);

const searchQuery = _.debounce(async (loading = false, search = "") => {
  const { data } = await axios.get(
    `/traffic_record_component/mv_file_record/city-list?search=${escape(
      search
    )}`,
    {
      headers: authHeader(),
    }
  );
  city_list.value = data.data;
  if (loading) {
    loading(false);
  }
}, 350);

const city_list = ref([]);

// const changeSelectedRecord = async (vehicle_record_id) => {
//   const confirm = await Swal.fire({
//     icon: "warning",
//     title: "Continue?",
//     text: "This will change the selected MV file record and generate a new NOV, do you want to proceed?",
//     showCancelButton: true,
//     confirmButtonText: "Proceed",
//   });

//   if (!confirm.isConfirmed) {
//     return;
//   }

//   try {
//     store.dispatch("globals/loading", null, { root: true });
//     console.log(traffic_record.value.id);

//     const inputs = {
//       vehicle_record_id: vehicle_record_id,
//     };

//     await axios.post(
//       `/traffic_record_component/mv_file_record/reselect/${traffic_record.value.id}`,
//       inputs,
//       {
//         headers: authHeader(),
//       }
//     );

//     window.location.reload();

//     store.dispatch("globals/loaded", null, { root: true });
//   } catch (error) {
//     Swal.fire({
//       icon: "error",
//       title: "Oops...",
//       text: error,
//     });
//     store.dispatch("globals/loaded", null, { root: true });
//   }
// };
</script>

<template>
  <b-overlay :show="loading">
    <div class="row">
      <div
        :class="[props.editable ? 'col-md-12' : 'col-12']"
        v-for="(api, index) in mv_file_record"
        :key="index"
      >
        <div
          class="card"
          v-if="
            api && (api.selected)
          "
        >
          <div class="card-body overflow-auto">
            <table class="table table-bordered table-sm table-light m-0">
              <tbody v-if="api.has_vehicle_record == 0">
                <tr v-if="props.editable">
                  <!-- <th colspan="2" class="text-center">
                    {{ index.toUpperCase() }}
                    LTO RECORD
                  </th> -->
                </tr>
                <tr>
                  <th colspan="2" class="text-center">MV File Record</th>
                </tr>
                <tr>
                  <th colspan="2" class="text-center">NO RECORD FOUND</th>
                </tr>
              </tbody>
              <tbody v-if="api.has_vehicle_record == 1">
                <tr v-if="props.editable">
                  <!-- <th colspan="2" class="text-center">
                    {{ index.toUpperCase() }}
                    <span
                      v-if="api.selected"
                      class="badge badge-success bg-success"
                      >Selected</span
                    >
                  </th> -->
                </tr>
                <tr>
                  <th colspan="2" class="text-center">MV File Record</th>
                </tr>
                <!-- <tr v-if="roleExist('lto-record')">
                  <td colspan="2">
                    <label class="text-bold">Owner Name</label>
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      :value="api.current_owner_name"
                    />
                  </td>
                </tr>
                <tr v-if="roleExist('lto-record') && !props.editable">
                  <td colspan="2">
                    <label class="text-bold">Owner Address</label>
                    <textarea
                      disabled
                      rows="2"
                      type="text"
                      class="form-control"
                      :value="
                        slicedOwnerAddress(
                          api.current_owner_address
                            .replace(/[\d,]/g, '')
                            .replace(/\s+/g, ' ')
                            .toUpperCase()
                            .split(' ')
                        )
                      "
                    />
                    <label class="small text-bold">{{
                      api.current_owner_address
                    }}</label>
                  </td>
                </tr> -->
                <!-- <tr>
                  <td colspan="2">
                    <label class="text-bold">City/Municipality, Province</label>
                    <div class="row">
                      <div class="col-md-6">
                        <textarea
                          v-if="
                            traffic_record.phase_id != 4 ||
                            traffic_record.is_dispute == 1
                          "
                          disabled
                          rows="2"
                          type="text"
                          class="form-control"
                          :value="
                            slicedOwnerAddress(
                              api.current_owner_address
                                .replace(/[\d,]/g, '')
                                .replace(/\s+/g, ' ')
                                .toUpperCase()
                                .split(' ')
                            )
                          "
                        />
                      </div>
                      <div class="col-md-6">
                        <v-select
                          :disabled="!api.selected"
                          v-if="props.editable"
                          :options="city_list"
                          placeholder="Select City"
                          :get-option-label="
                            (option) => {
                              return `${option.name + ', ' + option.province}`;
                            }
                          "
                          :value="city_list"
                          :reduce="(cities) => cities.id"
                          append-to-body
                          v-model="api.city_id"
                        />
                      </div>
                    </div>
                    <input
                      v-if="!props.editable && !api.city"
                      type="text"
                      class="form-control"
                      disabled
                    />
                    <input
                      v-if="!props.editable && api.city"
                      type="text"
                      class="form-control"
                      disabled
                      :value="api.city.name + ', ' + api.city.province"
                    />
                  </td>
                </tr> -->
                <tr>
                  <td
                    class="w-50"
                    v-if="traffic_record.registration_type_id == 1"
                  >
                    <label class="text-bold">Plate no.</label>
                    <input
                      disabled
                      type="text"
                      class="form-control"
                      :value="api.plate_number"
                    />
                  </td>
                  <td
                    class="w-50"
                    v-if="traffic_record.registration_type_id == 2"
                  >
                    <label class="text-bold">CS No.</label>
                    <input
                      disabled
                      type="text"
                      class="form-control"
                      :value="api.conduction_number"
                    />
                  </td>
                  <td>
                    <label class="text-bold">MV File No.</label>
                    <input
                      disabled
                      type="text"
                      class="form-control"
                      :value="api.file_number"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="w-50">
                    <label class="text-bold">Maker</label>
                    <input
                      disabled
                      type="text"
                      class="form-control"
                      :value="api.make"
                    />
                  </td>
                  <td>
                    <label class="text-bold">Series</label>
                    <input
                      disabled
                      type="text"
                      class="form-control"
                      :value="api.series"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="w-50">
                    <label class="text-bold">Year Model</label>
                    <input
                      disabled
                      type="text"
                      class="form-control"
                      :value="api.year_model"
                    />
                  </td>
                  <td>
                    <label class="text-bold">Classification</label>
                    <input
                      disabled
                      type="text"
                      class="form-control"
                      :value="api.classification"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <label class="text-bold">Body Type</label>
                    <input
                      disabled
                      type="text"
                      class="form-control"
                      :value="api.body_type"
                    />
                  </td>
                </tr>
                <tr
                  v-if="
                    api.selected &&
                    props.lgu_has_speed_violation.includes(
                      traffic_record.queue.lgu_id
                    ) &&
                    props.editable
                  "
                >
                  <td class="w-50">
                    <label class="text-bold">Speed Limit</label>
                    <div class="input-group">
                      <input
                        class="form-control"
                        type="number"
                        v-model="input_speed_limit"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2"
                          >km/h</span
                        >
                      </div>
                    </div>
                  </td>
                  <td>
                    <label class="text-bold">Vehicle Speed</label>
                    <div class="input-group">
                      <input
                        disabled
                        class="form-control"
                        type="number"
                        :value="traffic_record.vehicle_speed"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2"
                          >km/h</span
                        >
                      </div>
                    </div>
                  </td>
                </tr>
                <!-- <tr>
                  <td colspan="2" class="text-center" v-if="props.editable">
                    <button
                      type="button"
                      class="btn btn-success"
                      v-if="!api.selected"
                      @click="changeSelectedRecord(api.id)"
                    >
                      Select
                    </button>
                    <button
                      type="button"
                      class="btn btn-success"
                      v-if="api.selected"
                      disabled
                    >
                      Selected
                    </button>
                  </td>
                </tr> -->
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<style>
.vs--searchable .vs__dropdown-toggle {
  background: white;
}

:root {
  --vs-font-size: 0.8rem;
}
</style>
